import { getRooms } from "@/dispatchers/pharmacyServiceDispatchers.js";
import { getPharmaciesByCompanyId,getCompanyPharmaciesCount } from "@/dispatchers/locationDispatchers.js";
import { useTitanApp } from "@/hooks/useTitanApp";
// import {
//   Location,
//   Room,
//   defaultLocations,
// } from "./settings/locationsSettingsData";
// import { Role, defaultRoles } from "./settings/rolesSettingsData";
// import { Service, defaultServices } from "./settings/servicesSettingsData";
// import { Team } from "./settings/teamsSettingsData";
import { getAllGenerals } from "@/dispatchers/generalDispatchers";
import {
  getTeamsRoles,
  getPermissions,
  getTeamsByCompanyId,
} from "@/dispatchers/teamDispatchers";
import { getmarketApps } from "@/dispatchers/marketAppDispacher";
import {
  getmembers,
  getDefaultCompanyServices,
  getPendingInvites,
  getmembersV2
} from "@/dispatchers/memberDispatchers";
import useTitanTeam from "@/hooks/useTitanTeam";
import { getRoles } from "@/dispatchers/teamDispatchers";
import { getOrbitAgencyServicesByCompanyId } from "@/dispatchers/memberDispatchers";
import { getServicesByCompany } from "@/dispatchers/typeDispatchers";
import {
  getEmailsAndSmsTemplates,
  getAiTemplateByCompanyId,
  getPreConsultTemplateByCompanyId,
  getDefaultMessageTemplate,
} from "@/dispatchers/templateDispatchers";
import {
  getPatientConsultationsCount,
  getAllDocumentsByEmail,
} from "@/dispatchers/patientDispatchers";
import { getAllCompanyDocumentsByCompanyId } from "@/dispatchers/companyDocumentsDispatchers";
import {
  getTrackServiceBilling,
  getCompanySubscriptions,
  getCompanyLedgerSummary,
  getCompanyInvoicesByCompanyId,
  getCompnayUserCount,
  getCompanySubscriptionCosts
} from "@/dispatchers/companyServiceBillingDispatchers";
import { useRef, useCallback } from "react";
// export type { Location, Room, Role, Service, Team };
// Define tab types
type SettingsTab =
  | "general"
  | "locations"
  | "members"
  | "roles"
  | "services"
  | "teams"
  | "marketplace"
  | "templates"
  | "preconsult"
  | "consultation"
  | "billing";

// export interface SettingsData {
//   locations: Location[];
//   roles: Role[];
//   services: Service[];
//   teams: Team[];
//   installedApps: Set<string>;
// }
// export interface SettingsData {
//   locations: Location[];
//   roles: Role[];
//   services: Service[];
//   teams: Team[];
//   installedApps: Set<string>;
// }

// Default/Sample data using imported defaults
// export const defaultSettingsData: SettingsData = {
//   locations: defaultLocations,
//   roles: defaultRoles,
//   services: defaultServices,
//   teams: defaultTeams,
//   installedApps: new Set(["titan"]),
// };

export const useSettingsTabSwitcher = () => {
  const { appState, onboardingVerificationState } = useTitanApp();
  const { companyId, currentCompanyId,company } = appState;
  const { userData } = onboardingVerificationState || {};
    const switchTabWithData = useCallback(
    async (tabId: SettingsTab): Promise<void> => {
      try {
        const accountType = userData?.accountType === 2 ? 2 : 1;

        const tabApiMap: Record<SettingsTab, (() => Promise<any>)[]> = {
          general: [
            () =>
              getAllGenerals(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
          ],

          locations: [
            () =>
              getPharmaciesByCompanyId(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
               () =>
              getCompanySubscriptions(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
              () =>
                getCompanyPharmaciesCount(
                  currentCompanyId !== "" ? currentCompanyId : companyId,
                ),
                () =>
              getCompanyLedgerSummary(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
          ],

          members: [
            () =>
              getmembersV2(currentCompanyId !== "" ? currentCompanyId : companyId),
            () =>
              getTeamsRoles(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () =>
              getDefaultCompanyServices(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () =>
              getAllGenerals(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () =>
              getPharmaciesByCompanyId(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () =>
              getCompanySubscriptions(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () =>
              getTeamsByCompanyId(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () =>
              getPendingInvites(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
          ],

          teams: [
            () =>
              getmembers(currentCompanyId !== "" ? currentCompanyId : companyId),
            () =>
              getTeamsByCompanyId(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () =>
              getPharmaciesByCompanyId(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
          ],

          roles: [
            () =>
              getTeamsRoles(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () => getPermissions(),
          ],

          services: [
            () =>
              getmembers(currentCompanyId !== "" ? currentCompanyId : companyId),
            () =>
              getRooms(currentCompanyId !== "" ? currentCompanyId : companyId),
          () =>
            getPharmaciesByCompanyId(
              currentCompanyId !== "" ? currentCompanyId : companyId,
            ),
            () =>
              getEmailsAndSmsTemplates(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () =>
              getDefaultCompanyServices(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () =>
              getPreConsultTemplateByCompanyId(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () =>
              getAiTemplateByCompanyId(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () =>
              getDefaultMessageTemplate(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
          ],

          templates: [
            () =>
              getEmailsAndSmsTemplates(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
          ],

          preconsult: [
            () =>
              getPreConsultTemplateByCompanyId(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () =>
              getAiTemplateByCompanyId(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
          ],

          consultation: [
            () =>
              getAllCompanyDocumentsByCompanyId(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () =>
              getAiTemplateByCompanyId(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            // () =>
            //   getPatientConsultationsCount(
            //     currentCompanyId !== "" ? currentCompanyId : companyId,
            //   ),
          ],

          billing: [
            () =>
              getCompanyLedgerSummary(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () =>
              getCompanyInvoicesByCompanyId(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () =>
              getCompnayUserCount(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
            () =>
              getCompanySubscriptions(
                currentCompanyId !== "" ? currentCompanyId : companyId,
              ),
              () =>
                getCompanyPharmaciesCount(
                  currentCompanyId !== "" ? currentCompanyId : companyId,
                ),
                () => getCompanySubscriptionCosts(company?.companySubscriptionType ?? 0)
          ],

          marketplace: [() => getmarketApps()],
        };

        const apiCalls = tabApiMap[tabId] || [];

        await Promise.all(apiCalls.map((call) => call()));
      } catch (error) {
        console.error(`Error loading data for tab ${tabId}:`, error);
      }
    },
    [appState, onboardingVerificationState, companyId, currentCompanyId, userData],
  );

  return { switchTabWithData };
};
